module.exports = { id: "arrow", url: "/build/app/img/symbols.svg#arrow", viewBox: "", toString: function() { return this.url; } };